module.exports = __webpack_public_path__ + "img/it.cf22d4ce.svg";